import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTrashCanIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M2.66634 3.33203L3.09677 10.6492C3.17992 12.0628 3.22149 12.7696 3.52319 13.306C3.78878 13.7782 4.19189 14.1583 4.67885 14.3957C5.23201 14.6654 5.94004 14.6654 7.35608 14.6654H8.64327C10.0593 14.6654 10.7673 14.6654 11.3205 14.3957C11.8075 14.1583 12.2105 13.7782 12.4761 13.306C12.7779 12.7696 12.8194 12.0628 12.9026 10.6492L13.333 3.33203M2.66634 3.33203H1.33301M2.66634 3.33203H13.333M13.333 3.33203H14.6663M10.6663 3.33203L10.3643 2.42606C10.2332 2.03266 10.1677 1.83595 10.046 1.69052C9.93861 1.5621 9.80074 1.46269 9.64494 1.40142C9.46847 1.33203 9.26114 1.33203 8.84647 1.33203H7.15288C6.73821 1.33203 6.53086 1.33203 6.35443 1.40142C6.19864 1.46269 6.06071 1.5621 5.95332 1.69052C5.8317 1.83595 5.76613 2.03266 5.63499 2.42606L5.33301 3.33203M6.66634 6.66536V11.332M9.33301 6.66536L9.33301 11.332",
		stroke: "#EFEEF0",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgTrashCanIcon;
